import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Lock } from "lucide-react";
import { Logo } from "./Logo";

export default function Footer({ settings }) {
  return (
    <footer className="relative mt-24 border-t border-blue-500/10 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-3">
        <div className="space-y-4">
          <Logo size="md" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            {settings?.tagline || "Porque há momentos que não conseguimos explicar, apenas viver."}
          </p>
        </div>
        <div className="space-y-3">
          <div className="label">Navegação</div>
          <div className="flex flex-col gap-2 text-sm text-slate-300">
            <Link to="/" className="hover:text-blue-400">Início</Link>
            <Link to="/proximo-encontro" className="hover:text-blue-400">Próximo Encontro</Link>
            <Link to="/memorias" className="hover:text-blue-400">Memórias</Link>
            <Link to="/palavra" className="hover:text-blue-400">Palavra</Link>
            <Link to="/sobre" className="hover:text-blue-400">Sobre</Link>
            <Link to="/contato" className="hover:text-blue-400">Contato</Link>
          </div>
        </div>
        <div className="space-y-3">
          <div className="label">Conecte-se</div>
          <div className="flex flex-col gap-3">
            {settings?.instagram_url && (
              <a data-testid="footer-instagram" href={settings.instagram_url} target="_blank" rel="noreferrer" className="btn-ghost justify-start text-sm w-fit">
                <Instagram size={16} /> {settings?.instagram_handle || "Instagram"}
              </a>
            )}
            {settings?.whatsapp_number && (
              <a data-testid="footer-whatsapp" href={`https://wa.me/${settings.whatsapp_number.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="btn-ghost justify-start text-sm w-fit">
                <MessageCircle size={16} /> Falar com a equipe
              </a>
            )}
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-slate-500 hover:text-blue-400 inline-flex items-center gap-1 mt-2">
              <Lock size={12} /> Acesso administrativo
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-blue-500/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Conexão Inefável. Um movimento de amizade, fé e propósito.
      </div>
    </footer>
  );
}
